import React from "react";
import {findDOMNode} from "react-dom";
import Popover from "../../../../../../../gd-components/gd-popover/popover-v2";
import PopoverPosition from "../../../../../../../gd-components/gd-popover/popover-position";
import DatepickerContent from "../../../../../../../gd-components/datetime/datepicker/datepicker-content";
// import {Column} from "../../../../../../../gd-modules/manager/columns/types";
import ItemModel from "../../../../../../../model2/item/item-model";
import ProjectTableManager from "../../../../../../../../app/project/table/manager/manager";
import Moment from "moment/moment";
import {SCHEDULE_SOMEDAY} from "../../schedule";

const debug = "FieldTaskEndDate_Popover"
// const debug = "false"

type Props = {
    // column   : Column
    field    : any
    // listItem : ItemModel
    manager  : ProjectTableManager
    parent   : any
    value    : any
}

export default function FieldTaskSchedule_Popover(props: Props) {

    debug && console.log(debug, "render",  props)

    const onSelect = (date:any) => {
        props.parent.hidePopover();
        props.parent.onValueChange(date);
    };

    const scheduleToSomeday = () => {
        onSelect(SCHEDULE_SOMEDAY)
        // props.manager.setSchedule(props.listItem.id, null, 2)
        // gd.api.Task.scheduleSomeday(props.listItem.item.id)
        // props.parent.hidePopover();
    }

    const value = props.value
    const minDate = Moment()

    return (
        <Popover position={PopoverPosition.top()}
                 getTargetFunc={()=>findDOMNode(props.parent)}
                 onClickOutside={()=>{props.parent.hidePopover()}}>

            <DatepickerContent value        = {value}
                               onSelect     = {onSelect}
                               minDate      = {minDate}
                               onSelectSomeday={scheduleToSomeday}
                               btnToday     = {true}
                               btnTomorrow  = {true}
                               btnSomeday   = {true}
            />
        </Popover>
    );
}
